import { PageTemplate } from '../../common/PageWrapper';

export function Certificate() {
  const certificates = [
    {
      title: "What is Data Science?",
      desc: "Mempelajari konsep dasar data science, teknik analisis data, dan implementasinya di berbagai bidang.",
      score: "100%",
      img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=200&q=80"
    },
    {
      title: "HTML, CSS, dan Javascript untuk Web Developers",
      desc: "Mempelajari dasar-dasar HTML, CSS, dan Javascript untuk membangun website interaktif dan responsif.",
      score: "97%",
      img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=200&q=80"
    },
    {
      title: "Digital Marketing",
      desc: "Memahami strategi pemasaran digital, SEO, dan media sosial untuk mengembangkan brand.",
      score: "97%",
      img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=200&q=80"
    }
  ];

  return (
    <PageTemplate>
      <div className="px-4 py-8 md:px-10 md:py-10">
        <h1 
          className="text-2xl md:text-5xl font-bold mb-8" 
          style={{ color: '#184D47' }}
        >
          Sertifikat
        </h1>

        <div className="space-y-6 w-full">
          {certificates.map((cert, i) => (
            <div
              key={i}
              className="w-full flex items-center justify-between bg-[#184D47] rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
            >
              {/* Gambar & Teks */}
              <div className="flex items-center gap-6 w-full">
                <img
                  src={cert.img}
                  alt={cert.title}
                  className="rounded-xl w-40 h-24 md:w-56 md:h-32 object-cover shadow-sm"
                  loading="lazy"
                />
                <div className="flex-1 text-white">
                  <h3 className="text-lg md:text-xl font-semibold mb-1">
                    {cert.title}
                  </h3>
                  <p className="hidden md:block text-sm md:text-base mb-2 opacity-90">
                    {cert.desc}
                  </p>
                  <p className="text-xs md:text-sm opacity-80">
                    Nilai yang Diperoleh: <span className="font-semibold">{cert.score}</span>
                  </p>
                </div>
              </div>

              {/* Panah SVG */}
              <button className="bg-white p-3 rounded-full shadow hover:bg-gray-100 transition">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-5 h-5 text-[#184D47]"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      </div>
    </PageTemplate>
  );
}
